var _path, _path2, _path3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMonestoLogoShort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3865 22.6165H13.0585H0.950899L0 27.9998H22.4295L23.3865 22.6165Z",
    fill: "url(#paint0_linear_2634_15327)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2668 11.2129H15.1351H3.00825L2.09961 16.357H14.2179H23.3496L24.2668 11.2129Z",
    fill: "url(#paint1_linear_2634_15327)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3882 0H4.95871L4.00781 5.38334H16.1032H26.4311L27.3882 0Z",
    fill: "url(#paint2_linear_2634_15327)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2634_15327",
    x1: 1.4846,
    y1: 25.2015,
    x2: 22.4959,
    y2: 25.2015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A263E4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A263E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2634_15327",
    x1: 3.99942,
    y1: 13.8318,
    x2: 24.5164,
    y2: 14.8206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A263E4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.950753,
    stopColor: "#A263E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2634_15327",
    x1: 5.70074,
    y1: 2.45335,
    x2: 27.4536,
    y2: 2.45335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0403546,
    stopColor: "#A263E4",
    stopOpacity: 0.0452942
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A263E4"
  })))));
}

export default __webpack_public_path__ + "media/7e192005.svg";
export { SvgMonestoLogoShort as ReactComponent };